import React from 'react';
import { connect } from 'react-redux';
import { client } from '../actions/';
import { authHeader } from '../helpers/auth-header';
import { Checkbox, Icon, Row, Col, Tooltip, Button, Modal } from 'antd'
import { dspxSorter } from '../helpers/dspx-sort';
import moment from 'moment';
import warrantyActions  from '../actions/warranty.actions'
import PhoneNumber from './PhoneNumber/PhoneNumber';

const confirm = Modal.confirm;

class WarrantyInfo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      info: null,
      dataFetching: false,
    }
  }

  getInfo = () => {
    this.setState({ dataFetching: true })
    const rurl = '/warranty/info/' + this.props.request;
    client.get(rurl, { headers: authHeader() }).then(res => {
      this.setState({ info: res.data, dataFetching: false })
    }).catch(err => {
      this.setState({ info: {}, dataFetching: false })
      console.log(err)
    })
  }

  componentDidMount() {
    this.getInfo();
  }

  componentWillReceiveProps = next => {
      if (next.postWarrantyRequestId == this.props.request && next.infoPosted) {
        this.getInfo();
        this.props.dispatch({
          type: 'POST_WARRANTY_INFO_RESET'
        })  
      }
  }

  render() {
    const i = this.state.info 

    return <div style={{ ...this.props.style }} className={`dspx-warranty-info`}>

      <Row align='middle'>
        <Col span={22}>
          <span>Гарантия</span>
          {this.props.canChangeWarranty && (
            <span style={{ paddingLeft: 10 }}>
              <Tooltip title="Изменить" placement="bottom">
                <Button
                  shape="circle"
                  icon="edit"
                  onClick={() => {
                    this.props.dispatch(
                      warrantyActions.openWarrantyInfoModal(
                        this.props.request,
                        i
                      )
                    );
                  }}
                />
              </Tooltip>
            </span>
          )}

        </Col></Row>
      <Row style={{marginTop: '10px'}}>
        <Col span={22}>
          <Row>
            <Col span={4} >
              <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#58a89e' }}>Подрядчик:</span>
            </Col>
            <Col span={20} >
              <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#1aa0d6', marginLeft: '8px' }}>
                {i && i.organization && i.organization.inn || 'не указано'}
              </span>
              <span style={{ marginLeft: '8px' }}>
                {i && i.organization && i.organization.name }
              </span>
              <span style={{ marginLeft: '8px', color: '#19867d', fontStyle:'italic' }}>
                {i && i.organization && i.organization.directorFio } 
            </span>
            </Col>
          </Row>
          <Row>
            <Col span={4} >
            <span style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>
                {i && moment(i.startDate).format('DD.MM.YYYY') }
              </span>
            </Col>
            <Col span={20} >
              <span style={{ whiteSpace: 'nowrap', fontSize: '13px', color: '#888', marginLeft: '8px' }}>

							  <Icon type="phone" style={{ marginRight: '4px', fontSize: '13px' }} /> {i?.contactPhone ? <PhoneNumber phoneNumber={i.contactPhone} name={i.contactName} /> : 'не указано'}							
								<Icon type="user" style={{ marginRight: '4px', marginLeft: '8px', fontSize: '13px' }} /> {i && i.contactName || 'не указано'}

              </span>
            </Col>
          </Row>
          <Row>
            <Col span={4} >
              <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#58a89e' }}>Период:</span>
            </Col>
            <Col span={20} >
              <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#888', marginLeft: '8px', marginRight: '4px' }}>
                { i && moment(i.beginDate).format('DD.MM.YYYY') || 'не указано'}          
              </span>-            
              <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#888', marginLeft: '4px' }}>
                {i && moment(i.endDate).format('DD.MM.YYYY') || 'не указано'}
              </span>
            </Col>
          </Row>
        </Col>

        <Col span={2} >
          {this.props.canChangeWarranty && (
            <Tooltip title="Удалить документ" placement="left">
              <Button
                shape="circle"
                icon="close-circle"
                className="dspx-warranty-document-delete-button"
                style={{ marginTop: 16 }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleDeleteDocument(i);
                }}
              />
            </Tooltip>
          )}
        </Col>
      </Row>

    </div>

  }
}

function mapStateToProps(state) {
  const { warrantyInfoStore } = state;
  const {postWarrantyRequestId, infoPosted } = state.warrantyStore;
	return {...warrantyInfoStore, postWarrantyRequestId, infoPosted};
}

export default connect(mapStateToProps)(WarrantyInfo);